import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'reactstrap';
import './DocumentsCard.scss';
import Translate from '@securitize/ui-components/i18n/Translate';
import LaddaButton from 'react-ladda';
import classnames from 'classnames';

const DocumentsCard = forwardRef(({ documents, className, fullWidth }, ref) => {
  const documentsComponents = documents.map((document) => (
    <Row id={`document-${document.id}-card`} key={document.id} className="opportunity-documents__document">
      <Col
        xl={fullWidth ? 11 : 9}
        lg={fullWidth ? 10 : 8}
        md={10}
        sm={9}
        xs={7}
        className="opportunity-documents__document__description-col align-items-center justify-content-between d-flex"
        key={document.id}
      >
        <span className="font-16">
          {document.title}
        </span>
      </Col>
      <Col
        xl={fullWidth ? 1 : 3}
        lg={fullWidth ? 2 : 4}
        md={2}
        sm={3}
        xs={5}
        className="opportunity-documents__document__download-btn-col"
      >
        <LaddaButton
          className="btn issuer-button-outline"
          id={`btn-download-document-${document.id}`}
          onClick={() => window.open(document.documentUrl, '_blank')}
          disabled={!document.isAccessible}
        >
          <Translate translationKey="Texts.download" />
        </LaddaButton>
      </Col>
    </Row>
  ));

  const showRestrictedDocumentsWarning = documents.some((doc) => !doc.isAccessible);

  return (
    <Card
      className={
        classnames('opportunity-documents border-0 box-shadow p-3 p-xl-4',
          { [className]: className, 'mt-4': !className })
      }
      innerRef={ref}
    >
      <span className="opportunity-documents__title font-20 mb-3">
        <i className="icon icon-document mr-3" />
        <span><Translate translationKey="Texts.documents" /></span>
      </span>
      {showRestrictedDocumentsWarning && (
        <p className="opportunity-documents__restricted-docs-warning">
          <Translate translationKey="Texts.restricted-documents-warning" />
          &nbsp;
          <strong><Translate translationKey="Texts.restricted-documents-warning-underlined" /></strong>
        </p>
      )}
      <div className="d-flex align-items-center flex-column">
        {documentsComponents.map((doc) => doc)}
      </div>
    </Card>
  );
});

DocumentsCard.defaultProps = {
  className: null,
  fullWidth: true,
};

DocumentsCard.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    documentUrl: PropTypes.string,
    id: PropTypes.number,
    order: PropTypes.number,
    isAccessible: PropTypes.bool,
  })).isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default DocumentsCard;
